import { motion } from 'framer-motion';
import { MarqueeStyles } from '../../styles/styles';

const Marquee = () => {
  const travelDistance = 85.7;

  return (
    <>
      <MarqueeStyles data-scroll-section className="sm:mb-40 mb-10">
        <div className="left text-jetLight opacity-[0.8]">
          <motion.span
            initial={{ left: 0 }}
            animate={{ left: `-${travelDistance}%` }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ left: 0 }}
            animate={{ left: `-${travelDistance}%` }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ left: 0 }}
            animate={{ left: `-${travelDistance}%` }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ left: 0 }}
            animate={{ left: `-${travelDistance}%` }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
        </div>
        <div className="right text-jetLight opacity-[0.8]">
          <motion.span
            initial={{ right: `${travelDistance}%` }}
            animate={{ right: 0 }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ right: `${travelDistance}%` }}
            animate={{ right: 0 }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ right: `${travelDistance}%` }}
            animate={{ right: 0 }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
          <motion.span
            initial={{ right: `${travelDistance}%` }}
            animate={{ right: 0 }}
            transition={{ ease: 'linear', duration: 12, repeat: Infinity }}>
            Proficiency
          </motion.span>
        </div>
      </MarqueeStyles>
    </>
  );
};

export default Marquee;
